import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconVolumeMute = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.1001 3.48601L3.4971 2.10001H3.5081L12.0001 10.592L21.9001 20.492L20.5031 21.889L18.2792 19.6542C17.1839 20.5537 15.891 21.2234 14.4743 21.5881L13.9259 19.4575C14.9506 19.1938 15.8937 18.7238 16.708 18.0937L16.6751 18.061L12.0001 13.386V20.789L6.5001 15.289H2.1001V8.68901H7.2921L2.1001 3.48601ZM19.7001 12C19.7001 8.41363 17.2472 5.39737 13.9259 4.54253L14.4743 2.41197C18.744 3.51091 21.9001 7.3855 21.9001 12C21.9001 13.4927 21.569 14.9112 20.9752 16.1833L20.7671 16.565L19.1273 14.9204C19.4963 14.021 19.7001 13.0355 19.7001 12ZM14.8001 7.68664C16.1274 8.64257 16.9869 10.2234 16.9869 12C16.9869 12.2461 16.9704 12.4884 16.9384 12.7258L14.4035 10.1972C14.1878 9.86579 13.9146 9.57932 13.6001 9.35285L14.8001 7.68664ZM11.989 3.189L9.68999 5.477L11.989 7.776V3.19999V3.189Z",
		fill: "black"
	})
});
export default SvgIconVolumeMute;
